import { render, staticRenderFns } from "./mallPagemange.vue?vue&type=template&id=f2e877e8&scoped=true"
import script from "./mallPagemange.vue?vue&type=script&lang=js"
export * from "./mallPagemange.vue?vue&type=script&lang=js"
import style0 from "./mallPagemange.vue?vue&type=style&index=0&id=f2e877e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e877e8",
  null
  
)

export default component.exports